import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { COLOR_BORDER, COLOR_FONT_GRAY } from '@assets/color';
import { css } from '@emotion/react';

const formStyle = css`
  border: none;
  padding: 3% 4%;
`;
const commentStyle = css`
  border: 1px solid ${COLOR_BORDER};
  border-radius: 30px;
  padding: 4px 10px;
`;

const InputWrapper = styled.input`
  font-size: ${({ textSize }) => `${textSize}px`};
  width: 100%;
  outline: none;
  box-sizing: border-box;
  ${({ inputType }) => (inputType === 'form' ? formStyle : commentStyle)};

  &::placeholder {
    color: ${COLOR_FONT_GRAY};
  }
`;

const Input = ({
  inputType,
  textSize,
  onChange,
  placeholder = '내용을 입력해주세요.',
  ...props
}) => {
  const handleChange = (e) => {
    onChange && onChange(e);
  };

  return (
    <InputWrapper
      inputType={inputType}
      textSize={textSize}
      autoComplete="off"
      onChange={handleChange}
      placeholder={placeholder}
      {...props}
    />
  );
};

Input.propTypes = {
  inputType: PropTypes.string,
  textSize: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

export default Input;
